export default __webpack_public_path__ + "static/media/barcode.5c827237.jpeg";